module.exports = __webpack_public_path__ + "static/media/harvestInformation.da71713b.svg";